import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authentification par cookie httpOnly (posé par le serveur) : aucun jeton côté JS.
const api = axios.create({ baseURL: API, withCredentials: true });

// Filet de sécurité : si le serveur exige un changement de PIN (compte créé par un admin),
// on force l'écran de changement de PIN où que soit l'utilisateur.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error?.response?.data?.detail;
    if (error?.response?.status === 403 && detail === "PIN_CHANGE_REQUIRED") {
      if (!window.location.pathname.startsWith("/change-pin")) {
        window.location.assign("/change-pin");
      }
    }
    return Promise.reject(error);
  }
);

// Les <img>/PDF sont same-origin : le cookie httpOnly authentifie automatiquement la requête.
export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const clean = path.startsWith("/api/files/") ? path.replace("/api/files/", "") : path;
  return `${API}/files/${clean}`;
};

export default api;
